import {
  GET_LABELS_REQUEST,
  GET_LABELS_SUCCESS,
  GET_LABELS_FAILURE,
  GET_LABELS_WITH_PAGINATION_REQUEST,
  GET_LABELS_WITH_PAGINATION_SUCCESS,
  GET_LABELS_WITH_PAGINATION_FAILURE,
  CREATE_LABEL_REQUEST,
  CREATE_LABEL_SUCCESS,
  CREATE_LABEL_FAILURE,
  UPDATE_LABEL_REQUEST,
  UPDATE_LABEL_SUCCESS,
  UPDATE_LABEL_FAILURE,
  DELETE_LABEL_REQUEST,
  DELETE_LABEL_SUCCESS,
  DELETE_LABEL_FAILURE,
  GET_PRINTERS_FOR_LABEL_REQUEST,
  GET_PRINTERS_FOR_LABEL_SUCCESS,
  GET_PRINTERS_FOR_LABEL_FAILURE,
} from "./labelCreationTypes";
import axios from "axios";
import Config from "../../config/index";

let baseUrl = Config.baseUrl;

const getLabelsRequest = () => {
  return {
    type: GET_LABELS_REQUEST,
  };
};

const getLabelsSuccess = (payload) => {
  return {
    type: GET_LABELS_SUCCESS,
    payload: payload,
  };
};

const getLabelsFailure = (error) => {
  return {
    type: GET_LABELS_FAILURE,
    payload: error,
  };
};

const getLabels = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(getLabelsRequest());

    let url = `${baseUrl}/label_size_without_pagination`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getLabelsSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getLabelsFailure(err.response));
      });
  };
};

const getLabelsWithPaginationRequest = () => {
  return {
    type: GET_LABELS_WITH_PAGINATION_REQUEST,
  };
};

const getLabelsWithPaginationSuccess = (payload) => {
  return {
    type: GET_LABELS_WITH_PAGINATION_SUCCESS,
    payload: payload,
  };
};

const getLabelsWithPaginationFailure = (error) => {
  return {
    type: GET_LABELS_WITH_PAGINATION_FAILURE,
    payload: error,
  };
};

const getLabelsWithPagination = (pageNo, rowsPerPage, search, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(getLabelsWithPaginationRequest());

    let url = `${baseUrl}/label_size?page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getLabelsWithPaginationSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getLabelsWithPaginationFailure(err.response));
      });
  };
};

const createLabelRequest = () => {
  return {
    type: CREATE_LABEL_REQUEST,
  };
};

const createLabelSuccess = (payload) => {
  return {
    type: CREATE_LABEL_SUCCESS,
    payload: payload,
  };
};

const createLabelFaliure = (error) => {
  return {
    type: CREATE_LABEL_FAILURE,
    payload: error,
  };
};

const createLabel = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(createLabelRequest());
    let url = `${baseUrl}/label_size`;

    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createLabelSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createLabelFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const updateLabelRequest = () => {
  return {
    type: UPDATE_LABEL_REQUEST,
  };
};

const updateLabelSuccess = (payload) => {
  return {
    type: UPDATE_LABEL_SUCCESS,
    payload: payload,
  };
};

const updateLabelFaliure = (error) => {
  return {
    type: UPDATE_LABEL_FAILURE,
    payload: error,
  };
};

const updateLabel = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(updateLabelRequest());
    let url = `${baseUrl}/label_size`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(updateLabelSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(updateLabelFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const deleteLabelRequest = () => {
  return {
    type: DELETE_LABEL_REQUEST,
  };
};

const deleteLabelSuccess = (payload) => {
  return {
    type: DELETE_LABEL_SUCCESS,
    payload: payload,
  };
};

const deleteLabelFaliure = (error) => {
  return {
    type: DELETE_LABEL_FAILURE,
    payload: error,
  };
};

const deleteLabel = (id, userId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(deleteLabelRequest());
    let url = `${baseUrl}/label_size?labelId=${id}&userId=${userId}`;

    return axios
      .delete(url, headers)
      .then((response) => {
        dispatch(deleteLabelSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(deleteLabelFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const getPrintersForLabelCreationRequest = () => {
  return {
    type: GET_PRINTERS_FOR_LABEL_REQUEST,
  };
};

const getPrintersForLabelCreationSuccess = (payload) => {
  return {
    type: GET_PRINTERS_FOR_LABEL_SUCCESS,
    payload: payload,
  };
};

const getPrintersForLabelCreationFailure = (error) => {
  return {
    type: GET_PRINTERS_FOR_LABEL_FAILURE,
    payload: error,
  };
};

const getPrintersForLabelCreation = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(getPrintersForLabelCreationRequest());

    let url = `${baseUrl}/asset/get_printer`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getPrintersForLabelCreationSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getPrintersForLabelCreationFailure(err.response));
      });
  };
};

export {
  getLabels,
  createLabel,
  updateLabel,
  deleteLabel,
  getLabelsWithPagination,
  getPrintersForLabelCreation,
};
